import React from 'react';
import { useMemo } from 'react';
import classNames from 'classnames';

import ios from '../assets/images/sprite-app-store-en.png';
import android from '../assets/images/sprite-google-play-en@2x.png';
import { getPlatform, Platform } from '../services/Platform';
import Tracking from '../services/Tracking';
import { useTranslationContext } from '../TranslationProvider';

import Image from './Image';

interface Props {
  className?: string;
  loading?: 'lazy';
  detectSystem?: boolean;
  height?: number;

  onClick?(platform: Platform);
}

export const androidMobileAppLink = () => `https://play.google.com/store/apps/details?id=cz.nom.smilecarweb`;
export const iosMobileAppLink = lang => `https://itunes.apple.com/cz/app/hoppygo/id1184613465?l=${lang}&mt=8`;

export default function MobileAppLinks({ className, loading, height = 48, onClick, detectSystem }: Props) {
  const { language: lang } = useTranslationContext();
  const showAndroid = useMemo(() => {
    if (!detectSystem || !('userAgent' in window.navigator)) return true;
    return Platform.IOS !== getPlatform(window.navigator.userAgent);
  }, [detectSystem]);

  const handleClick = (platform: Platform) => () => {
    Tracking.track('MOBILE_APP_LINK_CLICKED', platform);
    onClick?.(platform);
  };

  const style: React.CSSProperties = { maxHeight: height, width: 'auto' };

  return (
    <div className={classNames('d-flex align-items-center', className)}>
      {showAndroid && (
        <a
          href={androidMobileAppLink()}
          onClick={handleClick(Platform.ANDROID)}
          rel="noopener noreferrer"
          target="_blank"
        >
          <Image alt="Android" loading={loading} src={android} style={style} />
        </a>
      )}
      <a href={iosMobileAppLink(lang)} onClick={handleClick(Platform.IOS)} rel="noopener noreferrer" target="_blank">
        <Image alt="iOS" loading={loading} src={ios} style={style} />
      </a>
    </div>
  );
}
